var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "space rocket"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5463 8.56839C14.1763 7.96352 15.1989 7.96452 15.829 8.56938C16.459 9.17424 16.4601 10.1559 15.83 10.7608C15.1999 11.3657 14.1774 11.3646 13.5473 10.7598C12.9172 10.1549 12.9162 9.17325 13.5463 8.56839Z",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M19.9815 4.19329C14.5234 3.8374 7.78805 8.67401 7.06357 14.117C7.04684 14.5924 7.22755 15.042 7.56595 15.3669L8.93317 16.6794C9.27156 17.0043 9.73992 17.1778 10.2352 17.1617C15.9048 16.4657 20.9429 10.0003 20.5722 4.76035C20.5503 4.45079 20.304 4.21432 19.9815 4.19329Z",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.5334 14.0889L16.2187 18.3421C16.2187 18.7113 16.0013 19.0488 15.6573 19.214L13.2038 20.3917C12.9405 20.5181 12.633 20.5285 12.3611 20.4204C12.0891 20.3123 11.8794 20.0961 11.7863 19.8279L10.6387 17.1363",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M10.3294 8.1377L5.897 8.41057C5.51236 8.40802 5.15923 8.61433 4.98485 8.94346L3.74122 11.2906C3.60775 11.5425 3.59472 11.8376 3.70551 12.0995C3.81629 12.3613 4.03998 12.5641 4.31862 12.6553L7.11446 13.7756",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.47509 18.5835C7.2047 20.311 5.09813 19.9889 3.72461 20.187C3.93096 18.8683 3.60687 16.8571 5.4064 16.5977",
    stroke: "#1976D2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueRocket);
export default __webpack_public_path__ + "static/media/blue_rocket.70a1bb94db44f00f05978c4fc28ee77b.svg";
export { ForwardRef as ReactComponent };